<!-- Creates a layout with a left-positioned sidenav and explicit content. -->
<!-- <div style="width:300px; height:200px">
  <img mat-card-image src="http://via.placeholder.com/300x200" >
</div> -->
<!-- <mat-divider></mat-divider> -->
<mat-list>
<!--   <p class="sidenav-separator">Modules</p> -->
   
  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/data_manager">
      <mat-icon>view_list</mat-icon><span class="sidenav-menu-list">Data Manager</span>      
    </button>
  </mat-list-item>  
  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/business-account">
      <mat-icon>edit_location</mat-icon><span class="sidenav-menu-list">Business Account</span>      
    </button>
  </mat-list-item>
  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/demographics">
        <mat-icon>insert_chart</mat-icon><span class="sidenav-menu-list">Demographics</span>
    </button>
  </mat-list-item>

  <!-- <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/markets-report">
      <mat-icon>account_balance</mat-icon><span class="sidenav-menu-list">Markets Report</span>      
    </button>
  </mat-list-item> -->

  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/insights">
      <mat-icon>timeline</mat-icon><span class="sidenav-menu-list">Insights</span>
    </button>
  </mat-list-item>
  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/dimasi_configurator">
      <mat-icon>settings</mat-icon><span class="sidenav-menu-list">Dimasi Configurator</span>      
    </button>
  </mat-list-item>
  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" routerLink="/pin_generator">
      <mat-icon>edit_location</mat-icon><span class="sidenav-menu-list">Pin Generator</span>      
    </button>
  </mat-list-item>

  <mat-list-item class="flow-text">
    <button mat-button class="sidenav-button" (click)="openLanguageDialog()" mat-button>
      <mat-icon>location_searching</mat-icon><span class="sidenav-menu-list">Language Manager</span>
    </button>
  </mat-list-item>
    

  <div class="sidenav-logo-container" mat-list-item>
    <a href="//www.gapmaps.com" target="_blank"><img class="sidenav-logo" src="assets/images/gapmaps-logo.png"></a>
  </div>

</mat-list> 